module.exports = __webpack_public_path__ + "assets/eecf21fd4dfc76487f11c97d204dee83.png";